import { getHomeUrl } from '@telialt/core-navigation/src/utils/path';

/**
 * Extracts all available breadcrumb paths from the given page path.
 *
 * For example, given the path "/home/category/last-breadcrumb", it returns:
 * ["/home/category", "/home/category/last-breadcrumb"] ommiting parts that match the "/home" URL.
 *
 * @param currentPagePath - The current page path as a string.
 * @returns An array of breadcrumb paths, each representing a step in the navigation hierarchy.
 */
export const createBreadcrumbRoutes = (currentPagePath: string): string[] => {
    const homeUrl = getHomeUrl(currentPagePath);

    return currentPagePath
        .split('/')
        .filter(Boolean)
        .map((_, i, arr) => '/' + arr.slice(0, i + 1).join('/'))
        .filter((route) => route !== homeUrl);
};
